interface DesktopQuantitySelectorProps {
  quantity: number;
  maxQuantity: number | null;
  onQuantityChange: (quantity: number) => void;
  isDisabled: boolean;
  totalPrice: number;
  orderType?: 'DEADLINE_DISCOUNT' | 'RESERVATION_DISCOUNT' | 'REGULAR_ORDER';
}

export function DesktopQuantitySelector({ 
  quantity, 
  maxQuantity, 
  onQuantityChange, 
  isDisabled, 
  totalPrice,
  orderType
}: DesktopQuantitySelectorProps) {
  return (
    <div className="bg-gray-50 rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900">수량 선택</h3>
        <div className={`flex items-center border-2 border-gray-300 rounded-xl overflow-hidden ${
          isDisabled ? 'opacity-50' : ''
        }`}>
          <button
            onClick={() => onQuantityChange(quantity - 1)}
            className="p-3 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={quantity <= 1 || isDisabled}
          >
            <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
              <path d="M5 10H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
          <span className="px-6 py-3 min-w-[80px] text-center text-xl font-medium bg-white">
            {quantity}
          </span>
          <button
            onClick={() => onQuantityChange(quantity + 1)}
            className="p-3 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={(orderType !== 'RESERVATION_DISCOUNT' && maxQuantity !== null && quantity >= maxQuantity) || isDisabled}
          >
            <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
              <path d="M10 5V15M5 10H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Total Price */}
      <div className="text-right">
        <p className="text-2xl font-bold text-gray-900">
          총 {totalPrice.toLocaleString()}원
        </p>
      </div>
    </div>
  );
}